import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { CardContent, CardLinkClickEvent, PageSectionContent } from '@types';
import { SectionComponent } from '../section-component.interface';
import { ProfileService } from '@services';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LinkService } from '@services/link.service';
import { TopFormService } from '@literature/top-forms/service/top-form.service';
import { TitleTheme } from '@frk/eds-components';

@Component({
  selector: 'ft-staggered-section',
  templateUrl: './staggered-section.component.html',
})
export class StaggeredSectionComponent
  implements OnInit, SectionComponent, OnDestroy {
  /**
   * Bloomreach component
   */
  component: BrComponent;

  /**
   * Bloomreach page model
   */
  page: Page;

  /**
   * Page Section content
   */
  content: PageSectionContent;

  theme: string;
  titleTheme: TitleTheme;

  isLoggedIn: boolean;

  private unsubscribe$: Subject<void> = new Subject<void>();
  public link: string;

  constructor(
    private profileService: ProfileService,
    private ctaLinkService: LinkService,
    private topFormService: TopFormService
  ) {
    this.profileService
      .isLoggedIn$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      });
  }

  /**
   * Populate the component
   * @param component - A parameter
   * @param page - A parameter
   * @param content - A parameter
   */
  populate(
    component: BrComponent,
    page: Page,
    sectionType: string,
    content: PageSectionContent,
    theme: string,
    titleTheme: TitleTheme
  ) {
    this.component = component;
    this.page = page;
    this.content = content;
    this.theme = theme;
    this.titleTheme = titleTheme;
  }

  ngOnInit(): void {
    /**
     * Bring cards property on root to feed to EDS Media Cards component
     */
    if (this.content?.cards) {
      this.content?.cards?.forEach((card: CardContent) => {
        if (card?.link?.signInLink) {
          card.signInRequired = card.link.signInLink && !this.isLoggedIn;
        }
        card.downloadLocation = this.ctaLinkService.getDownloadLocationHref(
          this.page,
          card?.link,
          null
        );
        card.url = this.ctaLinkService.getHref(this.page, card?.link, null);
      });
    }
    if (this.content?.link?.url) {
      this.link = this.content?.link?.url;
    } else if (this.content?.link?.literatureCode) {
      this.link = this.topFormService.linkToNavigateDetailPage(
        this.content?.link?.literatureCode
      );
    }
  }

  linkToNavigateDetailPage(link): string {
    if (link?.url) {
      return link?.url;
    } else if (link?.literatureCode) {
      return this.topFormService.linkToNavigateDetailPage(link?.literatureCode);
    }
  }

  setDownloadLocation(event) {
    this.ctaLinkService.setUpdatedLinkData(event);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
